import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.kpi_form');
  }

  @on({ event: 'keyup', selector: '.kpi_input' })
  formButtonAvailable() {
    if ($('.kpi_input').val().length > 0) {
      $('.kpi_form_button').prop('disabled', false);
    } else {
      $('.kpi_form_button').prop('disabled', true);
    }
  }
}
